import { FormPagePropertyItemMailAddress } from 'backend';
import { RE_ENTER_PROPERTY_ID_PREFIX } from 'reEnter';
import { MAIL_ADDRESS_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '.';

export const getMailddressPropertyItemElement = (
  propertyItem: FormPagePropertyItemMailAddress,
): PropertyItemElement => {
  switch (propertyItem.inputFormat.inputType) {
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.free: {
      const mailAddress = document.querySelector<HTMLElement>(
        `input[id="${propertyItem.propertyId}"]`,
      );
      if (!mailAddress) return {};
      const reEnter = document.querySelector<HTMLElement>(
        `input[id="${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}"]`,
      );
      if (!reEnter) {
        return { mailAddress: mailAddress };
      }
      return {
        mailAddress: mailAddress,
        reEnter: reEnter,
      };
    }
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.atSignSeparated: {
      const local = document.querySelector<HTMLElement>(
        `input[name="${propertyItem.propertyId}-local"]`,
      );
      const domain = document.querySelector<HTMLElement>(
        `input[name="${propertyItem.propertyId}-domain"]`,
      );
      if (!local || !domain) {
        return {};
      }
      const reEnterLocal = document.querySelector<HTMLElement>(
        `input[name="${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}-local"]`,
      );
      const reEnterDomain = document.querySelector<HTMLElement>(
        `input[name="${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}-domain"]`,
      );
      if (!reEnterLocal || !reEnterDomain) {
        return {
          local: local,
          domain: domain,
        };
      }
      return {
        local: local,
        domain: domain,
        reEnterLocal: reEnterLocal,
        reEnterDomain: reEnterDomain,
      };
    }
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.domainPulldown: {
      const local = document.querySelector<HTMLElement>(
        `input[name="${propertyItem.propertyId}-local"]`,
      );
      const domain = document.querySelector<HTMLElement>(
        `select[name="${propertyItem.propertyId}-domain"]`,
      );
      if (!local || !domain) {
        return {};
      }
      const reEnterLocal = document.querySelector<HTMLElement>(
        `input[name="${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}-local"]`,
      );
      const reEnterDomain = document.querySelector<HTMLElement>(
        `select[name="${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}-domain"]`,
      );
      if (!reEnterLocal || !reEnterDomain) {
        return {
          local: local,
          domain: domain,
        };
      }
      return {
        local: local,
        domain: domain,
        reEnterLocal: reEnterLocal,
        reEnterDomain: reEnterDomain,
      };
    }
  }
};
